module.exports = __webpack_public_path__ + "img/empty_document.259a875a.png";